module.exports = __webpack_public_path__ + "static/ETA-Solutions-Logo-RGB-a6138572b6f73d5c0f4504688e6cc98a.png";